import { getCssSizeValue, getHtmlFromRedactorField, getPropSafely } from "@/utils/utils"
import styled from "styled-components"
import { BREAKPOINTS } from "@/styles/themeSettings"
import useHover from "@/hooks/useHover"
import { useEffect } from "react"

const StyledDescription = styled.div`
	color: ${(props) => props.theme.colors.richBlack};
	padding: 0 ${getCssSizeValue(8, BREAKPOINTS.MOBILE)};

	@media (min-width: ${({ theme }) => theme.breakpoints.desktop || 1024}px) and (orientation: landscape) {
		padding: unset;
	}
`

const DescriptionContent = ({ data, setHoveredId, handleDownload }) => {
	const id = getPropSafely(data, "id")
	const description = getHtmlFromRedactorField(getPropSafely(data, "description"))

	const [ref, hovering] = useHover({
		onMouseLeaveCallback: () => {
			setHoveredId(null)
		},
	})

	useEffect(() => {
		if (!hovering) return
		setHoveredId(id)
	}, [hovering])

	return (
		<div style={{ cursor: "pointer" }} ref={ref} className="col-mobile-8 col-tablet-4 col-desktop-4" onClick={handleDownload}>
			<StyledDescription className="typo-strawford typo-strawford-11" dangerouslySetInnerHTML={description} />
		</div>
	)
}

export default DescriptionContent
